var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path6, _path7, _path8, _path9, _ellipse, _path10, _path11, _g, _rect2, _path12, _path13, _path14, _path15, _ellipse2, _path16, _path17, _g2, _rect3, _path18, _path19, _path20, _path21, _ellipse3, _path22, _path23, _g3, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwimming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 148,
    viewBox: "0 0 283 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 106C146.51 106 168 84.5097 168 58C168 31.4903 146.51 10 120 10C93.4903 10 72 31.4903 72 58C72 84.5097 93.4903 106 120 106Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124 138C152.719 138 176 114.719 176 86C176 57.2812 152.719 34 124 34C95.2812 34 72 57.2812 72 86C72 114.719 95.2812 138 124 138Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152 148C180.719 148 204 124.719 204 96C204 67.2812 180.719 44 152 44C123.281 44 100 67.2812 100 96C100 124.719 123.281 148 152 148Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168 127C196.719 127 220 103.719 220 75C220 46.2812 196.719 23 168 23C139.281 23 116 46.2812 116 75C116 103.719 139.281 127 168 127Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155 100C181.51 100 203 78.5097 203 52C203 25.4903 181.51 4 155 4C128.49 4 107 25.4903 107 52C107 78.5097 128.49 100 155 100Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 143,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 137,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 84,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 2.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 20.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 22,
    width: 104,
    height: 104,
    rx: 52,
    fill: "#60A3FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.2 79.8989L114.266 79.3514C116.313 78.9859 118.408 78.9859 120.454 79.3514L126.586 80.4464C128.633 80.8118 130.728 80.8118 132.774 80.4464L138.906 79.3514C140.953 78.9859 143.048 78.9859 145.094 79.3514L151.226 80.4464C153.273 80.8118 155.368 80.8118 157.414 80.4464L163.546 79.3514C165.593 78.9859 167.688 78.9859 169.734 79.3514L172.8 79.8989",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115 91L117.195 90.5935C119.314 90.2012 121.486 90.2012 123.605 90.5935L127.995 91.4065C130.114 91.7988 132.286 91.7988 134.405 91.4065L138.795 90.5935C140.914 90.2012 143.086 90.2012 145.205 90.5935L149.595 91.4065C151.714 91.7988 153.886 91.7988 156.005 91.4065L160.395 90.5935C162.514 90.2012 164.686 90.2012 166.805 90.5935L169 91",
    stroke: "white",
    strokeWidth: 4.40004,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115 91L117.195 90.5935C119.314 90.2012 121.486 90.2012 123.605 90.5935L127.995 91.4065C130.114 91.7988 132.286 91.7988 134.405 91.4065L138.795 90.5935C140.914 90.2012 143.086 90.2012 145.205 90.5935L149.595 91.4065C151.714 91.7988 153.886 91.7988 156.005 91.4065L160.395 90.5935C162.514 90.2012 164.686 90.2012 166.805 90.5935L169 91",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120 102L120.499 101.886C123.067 101.303 125.733 101.303 128.301 101.886L129.299 102.114C131.867 102.697 134.533 102.697 137.101 102.114L138.099 101.886C140.667 101.303 143.333 101.303 145.901 101.886L146.899 102.114C149.467 102.697 152.133 102.697 154.701 102.114L155.699 101.886C158.267 101.303 160.933 101.303 163.501 101.886L164 102",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 161.351,
    cy: 64.9491,
    rx: 7.15,
    ry: 7.15025,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5 49L151.197 52.782C148.321 54.5074 146.676 57.717 146.955 61.0588L147.6 68.8007",
    stroke: "white",
    strokeWidth: 6.60011,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11304_9721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 54,
    width: 62,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.266 72.7537L111.2 73.3012V54.6006H172.8V73.3012L169.734 72.7537C167.688 72.3883 165.593 72.3883 163.546 72.7537L157.414 73.8487C155.368 74.2142 153.273 74.2142 151.226 73.8487L145.094 72.7537C143.048 72.3883 140.953 72.3883 138.906 72.7537L132.774 73.8487C130.728 74.2142 128.633 74.2142 126.586 73.8487L120.454 72.7537C118.408 72.3883 116.313 72.3883 114.266 72.7537Z",
    fill: "#24284E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11304_9721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.85 87.5029L148.348 60.8175C149.089 60.4014 150.024 60.7861 150.257 61.6029C153.236 72.0292 157.733 81.9602 163.605 91.0766L165.2 93.5531L100.85 87.5029Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 14.8809,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-5 203 14.8809)",
    fill: "#60A3FA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M217.089 44.9436L218.708 44.506C219.788 44.2139 220.912 44.1156 222.027 44.2156L225.368 44.5152C226.483 44.6152 227.606 44.5169 228.687 44.2248L231.925 43.3497C233.005 43.0576 234.129 42.9593 235.244 43.0593L238.585 43.3589C239.7 43.4589 240.824 43.3605 241.904 43.0685L245.142 42.1933C246.223 41.9012 247.347 41.8029 248.461 41.9029L250.132 42.0527",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M219.648 50.72L220.807 50.3989C221.925 50.0891 223.09 49.9871 224.245 50.0981L226.638 50.3282C227.793 50.4392 228.959 50.3373 230.077 50.0274L232.393 49.3852C233.511 49.0754 234.677 48.9734 235.832 49.0844L238.225 49.3145C239.38 49.4255 240.545 49.3236 241.663 49.0137L243.98 48.3716C245.098 48.0617 246.263 47.9597 247.418 48.0707L248.615 48.1858",
    stroke: "white",
    strokeWidth: 2.36925,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M219.648 50.72L220.807 50.3989C221.925 50.0891 223.09 49.9871 224.245 50.0981L226.638 50.3282C227.793 50.4392 228.959 50.3373 230.077 50.0274L232.393 49.3852C233.511 49.0754 234.677 48.9734 235.832 49.0844L238.225 49.3145C239.38 49.4255 240.545 49.3236 241.663 49.0137L243.98 48.3716C245.098 48.0617 246.263 47.9597 247.418 48.0707L248.615 48.1858",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M222.847 56.386L223.109 56.3017C224.459 55.8682 225.889 55.7431 227.294 55.9356L227.84 56.0105C229.245 56.203 230.675 56.0779 232.025 55.6444L232.55 55.4757C233.9 55.0422 235.33 54.9171 236.735 55.1096L237.281 55.1845C238.686 55.377 240.116 55.2519 241.466 54.8184L241.991 54.6498C243.341 54.2162 244.771 54.0911 246.176 54.2837L246.449 54.3211",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.289,
    cy: 34.5712,
    rx: 3.85,
    ry: 3.85013,
    transform: "rotate(-5 243.289 34.5712)",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M240.475 26.1957L237.271 28.5202C235.81 29.5807 235.078 31.3795 235.384 33.1591L236.094 37.2816",
    stroke: "white",
    strokeWidth: 3.55391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11304_9721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 215,
    y: 28,
    width: 35,
    height: 14
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M218.398 40.9677L216.779 41.4053L215.901 31.374L248.944 28.4831L249.822 38.5144L248.152 38.3646C247.037 38.2646 245.913 38.3629 244.832 38.655L241.594 39.5301C240.514 39.8222 239.39 39.9205 238.275 39.8206L234.934 39.5209C233.82 39.4209 232.696 39.5193 231.615 39.8114L228.377 40.6865C227.297 40.9786 226.173 41.0769 225.058 40.9769L221.717 40.6773C220.602 40.5773 219.479 40.6756 218.398 40.9677Z",
    fill: "#24284E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11304_9721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.893 49.5087L236.12 32.9652C236.497 32.7072 237.017 32.8697 237.18 33.2969C239.268 38.7499 242.146 43.866 245.723 48.4806L246.695 49.7341L211.893 49.5087Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.85352,
    y: 48,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(6 5.85352 48)",
    fill: "#60A3FA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9479 80.1994L15.6205 80.0788C16.737 79.9983 17.859 80.1162 18.9343 80.4271L22.1564 81.3586C23.2318 81.6695 24.3537 81.7874 25.4702 81.7069L28.8155 81.4657C29.932 81.3851 31.054 81.5031 32.1293 81.814L35.3514 82.7455C36.4268 83.0564 37.5487 83.1743 38.6652 83.0938L42.0105 82.8525C43.127 82.772 44.249 82.8899 45.3244 83.2008L46.9354 83.6666",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3578 86.3568L16.5562 86.2627C17.7128 86.1718 18.8762 86.2941 19.9886 86.6234L22.294 87.3059C23.4064 87.6353 24.5698 87.7575 25.7264 87.6667L28.1233 87.4784C29.2798 87.3876 30.4433 87.5098 31.5557 87.8392L33.861 88.5217C34.9734 88.851 36.1369 88.9733 37.2935 88.8824L39.6903 88.6942C40.8469 88.6033 42.0103 88.7256 43.1228 89.0549L44.2754 89.3962",
    stroke: "white",
    strokeWidth: 2.36925,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3578 86.3568L16.5562 86.2627C17.7128 86.1718 18.8762 86.2941 19.9886 86.6234L22.294 87.3059C23.4064 87.6353 24.5698 87.7575 25.7264 87.6667L28.1233 87.4784C29.2798 87.3876 30.4433 87.5098 31.5557 87.8392L33.861 88.5217C34.9734 88.851 36.1369 88.9733 37.2935 88.8824L39.6903 88.6942C40.8469 88.6033 42.0103 88.7256 43.1228 89.0549L44.2754 89.3962",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4164 92.5297L17.6902 92.497C19.0981 92.329 20.5257 92.479 21.8678 92.9361L22.3899 93.1138C23.7321 93.5709 25.1597 93.7209 26.5676 93.5529L27.1152 93.4876C28.5231 93.3196 29.9507 93.4697 31.2928 93.9267L31.8149 94.1045C33.1571 94.5615 34.5847 94.7115 35.9926 94.5435L36.5402 94.4782C37.9481 94.3102 39.3757 94.4603 40.7178 94.9173L40.9789 95.0062",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.6452,
    cy: 75.0157,
    rx: 3.85,
    ry: 3.85013,
    transform: "rotate(6 41.6452 75.0157)",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4805 66.2578L36.8922 67.9283C35.2552 68.6904 34.1937 70.3166 34.1547 72.1219L34.0644 76.3041",
    stroke: "white",
    strokeWidth: 3.55391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11304_9721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 66,
    width: 35,
    height: 15
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9912 76.5442L14.3185 76.6648L15.3711 66.6504L48.3586 70.1175L47.3061 80.1319L45.695 79.6662C44.6197 79.3553 43.4977 79.2374 42.3812 79.3179L39.0359 79.5591C37.9194 79.6397 36.7974 79.5217 35.7221 79.2108L32.5 78.2793C31.4247 77.9684 30.3027 77.8505 29.1862 77.931L25.8409 78.1723C24.7244 78.2528 23.6024 78.1349 22.5271 77.824L19.305 76.8925C18.2296 76.5816 17.1077 76.4637 15.9912 76.5442Z",
    fill: "#24284E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11304_9721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.97654 83.687L34.9145 72.0701C35.3345 71.889 35.8136 72.1476 35.8926 72.5982C36.9009 78.3492 38.7504 83.9205 41.3814 89.1329L42.0962 90.5489L7.97654 83.687Z",
    fill: "white"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 111.5L243.5 116",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16L56.5 23",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18 128.5L33 125",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimming);
export default __webpack_public_path__ + "static/media/swimming.14ee42e2f1689616c3d67cf90b7bfa4c.svg";
export { ForwardRef as ReactComponent };